export const MAX_COMMENTS_COUNTS = 99;
export const MOBILE_WIDTH = 900;
export const TOOLS_HEIGHT = 56;
export const CAN_EDIT = '1';

export const TRANSPORTATION_TIME = {
  CUSTOM: '1', // 自己設定交通時間。用於 customizeTransportationTimeFlag
  USE_DEFAULT_CALCULATE: '0', // 使用直接距離計算。用於 customizeTransportationTimeFlag
  CALCULATING: '-1', // 交通時間未知，計算中。用於 transportationTime
};
